
export default function FinalMessageSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 right-20 w-32 h-32 bg-yellow-400 rounded-full opacity-10"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-blue-400 rounded-full opacity-10"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-yellow-400/5 to-blue-400/5 rounded-full"></div>
      </div>
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-6 leading-tight">
            最後に──"原因不明"に終止符を。<br />
            <span className="text-yellow-400">20年間の『工具検査マスター環境』を自社に。</span>
          </h2>
        </div>
        
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-12">
          <div className="text-lg leading-relaxed space-y-6">
            <p className="text-gray-200">
              金属切削の現場では、原因不明のトラブルが必ず起きます。<br />
              「工具が怪しい」と疑っても、確認する"基準"がない。だから、追及が止まる。
            </p>
            
            <p className="text-white font-semibold text-xl">
              venturionは、生産性装置であると同時に、<br />
              工具寸法と状態を完璧に検査するマスターです。
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-20 h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-search-2-line text-black text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">基準寸法の絶対値測定</h3>
            <p className="text-gray-300">工具起因かを即切り分け</p>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-blue-400 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-time-line text-black text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">再現可能な『基準』</h3>
            <p className="text-gray-300">20年間保持<br />（年次メンテで精度を維持）</p>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-green-400 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-black text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-4 text-green-400">ブラックボックス化を拒否</h3>
            <p className="text-gray-300">原因追及を前進させる</p>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-yellow-400/20 to-blue-400/20 rounded-2xl p-8 text-center">
          <div className="text-lg leading-relaxed space-y-4">
            <p className="text-white">
              短期で回収できる投資であることに加え、<br />
              <strong className="text-yellow-400">"原因を数値で語れる仕組み"を20年間、あなたの現場に常設する。</strong>
            </p>
            <p className="text-xl font-bold text-white">
              これがventurionを持つ最大の強みです。
            </p>
            <p className="text-2xl font-bold text-yellow-400">
              ぜひ貴社の現場にこの『武器』を手に入れてください‼
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}